define('services/notifications/new-message-received',[
    'backbone',
    'mustache',
    'utils',
    'services/notifications/base-push-notification',
    'services/events/conversation-events',
    'services/session'
], function (
    Backbone,
    Mustache,
    U,
    BasePushNotification,
    ConversationEvents,
    Session
) {

    CONVERSATION_URL_MEMBER = "group/default/member/me/messages/{{conversationId}}";
    CONVERSATION_URL_SUPERVISOR = "supervisor/group/{{groupId}}/member/{{userId}}/messages/{{conversationId}}";

    var NewMessageReceived = BasePushNotification.extend({

        handleTap: function() {
            var notification = this.notification;

            var url = Mustache.render(this.getConversationUrl(), Mustache.getContext({
                groupId: notification.groupId,
                userId: notification.userId,
                conversationId: notification.conversationId,
            }));

            var obj = JSON.stringify({
                supervisor: Mustache.render(CONVERSATION_URL_SUPERVISOR, Mustache.getContext({
                    groupId: notification.groupId,
                    userId: notification.userId,
                    conversationId: notification.conversationId,
                })),
                member: Mustache.render(CONVERSATION_URL_MEMBER, Mustache.getContext({
                    groupId: notification.groupId,
                    userId: notification.userId,
                    conversationId: notification.conversationId,
                }))
            });

            localStorage.setItem('pushNotificationRedirection', obj);
            if (Session.isAuthenticated() && U.getCookieByName('fbTokenTC')) {
                ConversationEvents.redirectedToConversation();
                Backbone.history.navigate('#/' + url, true);
                localStorage.removeItem('pushNotificationRedirection');
            }
        },

        getConversationUrl: function() {
            if (this.notification.isSupervisor === "1") {
                return CONVERSATION_URL_SUPERVISOR;
            }
            return CONVERSATION_URL_MEMBER;
        },


    });

    return NewMessageReceived;
});

